<template>
  <div>
    <CRow class="mt-3 mb-4">
      <CCol md="6">
        <label class="d-block">Periodo:</label>
        <DateSelector class="z-custom-2 mb-2" :date="filter.periodo" @input="setPeriodo" />
      </CCol>
      <CCol col="6" class="pt-3">
        <label class="d-block">Trabajador:</label>
        <div class="d-flex margin-multi align-items-center">
          <multiselect
            v-model="filter.trabajadores"
            :options="trabajadores"
            :multiple="true"
            :loading="!showtable"
            label="label"
            track-by="label"
            placeholder="Trabajadores"
            :close-on-select="false"
            :clear-on-select="false"

          >
            <template #no-options>Sin resultados.</template>
          </multiselect>
          <transition name="fade">
            <div v-show="filter.trabajadores && filter.trabajadores.length" @click="()=>{filter.trabajadores = []}">
              <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
            </div>
          </transition>
        </div>
      </CCol>
      <CCol col="6" class="pt-3">
        <label class="d-block">Operador:</label>
        <div class="d-flex margin-multi align-items-center">
          <multiselect
            v-model="filter.operadores"
            :options="operadores"
            :multiple="true"
            :loading="!showtable"
            label="label"
            track-by="label"
            placeholder="Trabajadores"
            :close-on-select="false"
            :clear-on-select="false"

          >
            <template #no-options>Sin resultados.</template>
          </multiselect>
          <transition name="fade">
            <div v-show="filter.operadores && filter.operadores.length" @click="()=>{filter.trabajadores = []}">
              <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
            </div>
          </transition>
        </div>
      </CCol>
      <CCol col="6" class="pt-3">
        <label class="d-block">Actividad:</label>
        <div class="d-flex margin-multi align-items-center">
          <multiselect
            v-model="filter.actividades"
            :options="actividades"
            :multiple="true"
            :loading="!showtable"
            label="label"
            track-by="label"
            placeholder="Actividades"
            :close-on-select="false"
            :clear-on-select="false"

          >
            <template #no-options>Sin resultados.</template>
          </multiselect>
          <transition name="fade">
            <div v-show="filter.actividades && filter.actividades.length" @click="()=>{filter.actividades = []}">
              <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
            </div>
          </transition>
        </div>
      </CCol>
      <CCol col="6" class="pt-3">
        <CButton @click="()=>actualizarInfo('boton_labores')" color="primary"> Buscar</CButton>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      :title="'Eliminar ' + (deletePromptMeta.length > 1 ? 'documentos' : 'documento')"
      :centered="true"
      color="primary"
      :show="deletePrompt"
      :fade="true"
      >¿Seguro de eliminar {{ deletePromptMeta.length > 1 ? 'documentos' : 'documento' }}?
      <template #footer>
        <CButton @click="deletePrompt = false" color="secondary">Cancelar</CButton>
        <CButton @click="deletePromptAction" color="primary">Aceptar</CButton>
      </template>
    </CModal>

    <div class="w-100 d-flex justify-content-center align-items-center" v-if="isLoading">
      <div class="sk-flow">
        <div class="sk-flow-dot bg-primary"></div>
        <div class="sk-flow-dot bg-primary"></div>
        <div class="sk-flow-dot bg-primary"></div>
      </div>
    </div>
    <datatable v-else
      :columns="columns"
      :data="xdata"
      :total="total"
      :query="query"
      :tbl-style="tblStyle"
      :HeaderSettings="false"
      :Pagination="true"
      :selection="selection"
      :pageSizeOptions="[10, 50, 100, 1000]"
    >
      <div slot="trabajador_id" slot-scope="props" :class="{'ceil-error': props.rowData.errors.includes('trabajador_id')}">
        <Treeselect
        placeholder="Trabajador ..."
        :options="trabajadoresActivos"
        :searchable="true"
        :clearable="false"
        :open-on-click="true"
        :open-on-focus="true"
        :append-to-body="true"
        :width="200"
        :ref="'trabajador-' + props.rowIndex"
        :value="trabajadoresActivos.length > 0 ? props.rowData.trabajador_id : null"
        @input="(e)=>{
          props.rowData.trabajador_id = e
          onTreeSelect('trabajador', props.rowIndex)
        }"
        :title="getTitle(_xdata,props.rowIndex,'trabajador_id')"
        >
         <div slot="value-label" slot-scope="{ node }">{{ typeof node.id === 'string' ? node.id : (node.label.includes('(unknown)') ? 'Selecciona...' : node.label) }}</div>
        </treeselect>
      </div>
      <div slot="operador" slot-scope="props" :class="{'ceil-error': props.rowData.errors.includes('operador')}">
        <Treeselect
          :title="props.rowData.operador"
          :ref="'operador-' + props.rowIndex"
          placeholder="Operador ..."
          :options="operadores"
          :searchable="true"
          :clearable="false"
          :open-on-click="true"
          :open-on-focus="true"
          :append-to-body="true"
          :width="200"
          :value="(operadores&&operadores.length > 0) ? props.rowData.operador : null"
          @input="(e)=>{
            props.rowData.operador = e
            onTreeSelect('operador', props.rowIndex)
          }"
        >
         <div slot="value-label" slot-scope="{ node }">{{ typeof node.id === 'string' ? node.id : (node.label.includes('(unknown)') ? 'Selecciona...' : node.label) }}</div>
        </treeselect>
      </div>
      <div slot="actividad_id" slot-scope="props" :class="{'ceil-error': props.rowData.errors.includes('actividad_id')}">
        <Treeselect
          :title="getTitle(_xdata,props.rowIndex,'actividad_id')"
          :ref="'actividad-' + props.rowIndex"
          placeholder="Actividad ..."
          :options="actividadesArbol"
          :searchable="true"
          :open-on-click="true"
          :open-on-focus="true"
          :append-to-body="true"
          :disable-branch-nodes="true"
          :value="actividades.length > 0 ? props.rowData.actividad_id : null"
          @input="(e)=>{
            props.rowData.actividad_id = e
            onTreeSelect('actividad', props.rowIndex)
          }"
        >
         <div slot="value-label" slot-scope="{ node }">{{ node.label.includes('(unknown)') ? 'Selecciona...' : node.label }}</div>
        </treeselect>
      </div>
      <div slot="cantidad" slot-scope="props" :class="{'ceil-error': props.rowData.errors.includes('cantidad')}">
        <div class="input-group"
          :title="props.rowData.camtidad">
          <input
            class="form-control form-control-sm"
            type="number"
            min="1"
            v-model="props.rowData.cantidad"
          />
          <div class="input-group-append">
            <div class="input-group-text">
              <CBadge color="primary">{{
                actividadC[props.rowData.actividad_id]?(actividadC[props.rowData.actividad_id].unidad||''):''
              }}</CBadge>
            </div>
          </div>
        </div>
      </div>
      <div v-if="actividadC[props.rowData.actividad_id]?(actividadC[props.rowData.actividad_id].tipo_pago == 'fijo'):false"
        slot="cantidad_costo"
        slot-scope="props"
        :class="{'ceil-error': props.rowData.errors.includes('cantidad_costo')}"
      >
        <div class="input-group"
          :title="props.rowData.cantidad_costo">
          <input
            class="form-control form-control-sm"
            type="number"
            min="1"
            v-model="props.rowData.cantidad_costo"
          />
          <div class="input-group-append">
            <div class="input-group-text">
              <CBadge color="primary">{{
                trabajador(
                  props.rowData.trabajador_id,
                  props.rowData.tiempo_extra ? "unidad_extra" : "unidad"
                )
              }}</CBadge>
            </div>
          </div>
        </div>
      </div>
      <div v-if="actividadC[props.rowData.actividad_id]?(actividadC[props.rowData.actividad_id].tipo_pago == 'fijo'):false"
        slot="tiempo_extra"
        slot-scope="props"
      >
        <CSwitch
          class="mx-1"
          color="primary"
          variant="3d"
          :checked.sync="props.rowData.tiempo_extra"
        />
      </div>
      <div slot="ubicaciones" slot-scope="props" :class="{'ceil-error': props.rowData.errors.includes('ubicaciones')}">
        <Treeselect
          :ref="'ubicacion-' + props.rowIndex"
          placeholder="Ubicación ..."
          :options="getUbicacionesArbol(props.rowData.ubicacion_raiz_id)"
          :multiple="true"
          :clearable="false"
          :append-to-body="true"
          :open-on-focus="true"
          :open-on-click="true"
          :value="
            ubicacionesArbol.length > 0 ? props.rowData.ubicaciones : null
          "
          @input="(e)=>{
            props.rowData.ubicaciones = e
            onTreeSelect('ubicacion', props.rowIndex)
          }"
        >
         <div slot="value-label" slot-scope="{ node }" :class="{'ubi-error': node.label.includes('unknown')}">{{ node.label.includes('(unknown)') ? 'Selecciona...' : node.label }}</div>
        </Treeselect>
      </div>
      <div slot="ubicacion_raiz_id" slot-scope="props" :class="{'ceil-error': props.rowData.errors.includes('ubicacion_raiz_id')}">

        <Treeselect
          :title="getTitle(_xdata,props.rowIndex,'ubicacion_raiz_id')"
          :ref="'ubicacion_raiz_id-' + props.rowIndex"
          placeholder="Ubicacion raiz ..."
          :options="ubicacionesRaiz"
          :searchable="true"
          :clearable="false"
          :open-on-click="true"
          :open-on-focus="true"
          :append-to-body="true"
          :width="200"
          :value="ubicacionesRaiz.length > 0 ? props.rowData.ubicacion_raiz_id : null"
          @input="(e)=>{
            props.rowData.ubicacion_raiz_id = e
            onTreeSelect('ubicacion', props.rowIndex)
          }"
        >
         <div slot="value-label" slot-scope="{ node }">{{ typeof node.id === 'string' ? node.id : (node.label.includes('(unknown)') ? 'Selecciona...' : node.label) }}</div>
        </Treeselect>
      </div>
      <template slot="error" slot-scope="props">
        <p class="error-text" :title="props.rowData.error">{{ props.rowData.error }}</p>
      </template>
      <div slot="actions" slot-scope="props">
        <CButton
          :ref="'action-' + props.rowIndex"
          @click="onDeleteItem(props)"
          color="danger"
          square
          size="sm"
          class="p-0"
        >
          <CIcon name="cil-trash" />
        </CButton>
        <CButton
          v-if="props.rowData.dirty"
          :ref="'action-' + props.rowIndex"
          @click="onUndoItem(props)"
          color="secondary"
          square
          size="sm"
          class="p-0"
        >
          <CIcon name="cil-action-undo" />
        </CButton>
      </div>
      <div v-if="selection.length">
        <div class="d-flex pt-4">
          <div class="col pl-0">
            <masivo :selection="selection" :trabajadores="trabajadoresActivos" :actividades="actividadesArbol" :ubicaciones="ubicacionesArbol" :ubicacionesRaiz="ubicacionesRaiz" :operadores="operadores" :fields="masivoFields" @update-all="updateAll"></masivo>
          </div>
          <div class="col-auto pr-0">
            <CButton
              @click="onDeleteAll"
              color="danger"
              square
            >
              <CIcon name="cil-trash" />
            </CButton>
          </div>
        </div>
      </div>
    </datatable>
    <div hidden> {{ touches }} </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Datatable from 'vue2-datatable-component';
import DateSelector from "@/customComponents/DateSelector";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import mixin from './mixin/'


// import { customAlphabet } from 'nanoid'
// const nanoid = customAlphabet(
//   "1234567890abcdefghijklmnopqrstuvwxyz",
//   10
// );

export default {
  name: 'Labores',
  mixins: [mixin],
  components: {
    Datatable,
    DateSelector,
    Treeselect,
    Multiselect
  },
  data() {
    return {
      masivoFields: [
        {
          nombre:'Trabajadores',
          field: 'trabajador_id'
        }, {
          nombre:'Operadores',
          field: 'operador'
        }, {
          nombre:'Actividades',
          field: 'actividad_id'
        }, {
          nombre:'Ubicacion raiz',
          field: 'ubicacion_raiz_id'
        }, {
          nombre:'Ubicaciones',
          field: 'ubicaciones'
        }, {
          nombre:'Cant. Producida',
          field: 'cantidad'
        }, {
          nombre:'Cant. Pagar',
          field: 'cantidad_costo'
        }
      ],
      schema: 'labores',
      isCreated:false,
      columns: [
        {
          title: 'Fecha hora',
          field: 'fechahora_amigable',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          colStyle: {
            width: '150px',
          }
        },
        {
          title: 'Trabajador',
          field: 'trabajador_id',
          sortable: true,
          filterable: true,
          lists: 'trabajadores',
          thComp: 'FilterTh',
          tdClass: 'td-overflow',
          colStyle: {
            width: '125px'
          }
        },
        {
          title: 'Operador',
          field: 'operador',
          sortable: true,
          filterable: true,
          lists: 'operadores',
          thComp: 'FilterTh',
          tdClass: 'td-overflow',
          colStyle: {
            width: '125px'
          }
        },
        {
          title: 'Actividad',
          field: 'actividad_id',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          lists: 'actividades',
          tdClass: 'td-overflow',
          colStyle: {
            width: '150px'
          }
        },
        {
          title: 'Ubicaciones',
          field: 'ubicaciones',
          sortable: true,
          tdClass: 'td-overflow',
          colStyle: {
            width: '200px'
          }
        },
        {
          title: 'Ubicacion raiz',
          field: 'ubicacion_raiz_id',
          sortable: true,
          filterable: true,
          lists: 'ubicacionesRaiz',
          thComp: 'FilterTh',
          tdClass: 'td-overflow',
          colStyle: {
            width: '200px'
          }
        },
        {
          title: 'Cantidad<br>Producida',
          field: 'cantidad',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          tdClass: 'td-overflow',
          colStyle: {
            width: '160px'
          }
        },
        {
          title: 'Cantidad<br>Pagar',
          field: 'cantidad_costo',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          tdClass: 'td-overflow',
          colStyle: {
            width: '130px'
          }
        },
        {
          field: 'tiempo_extra',
          sortable: true,
          title: 'Tiempo Extra',
          colStyle: {
            width: '90px'
          }
        },
        {
          title: 'Tipo',
          field: 'tipo',
          sortable: true,
          colStyle: {
            width: '80px'
          }
        },
        {
          title: 'Tipo<br>pago',
          field: 'tipo_pago',
          sortable: true,
          colStyle: {
            width: '85px'
          }
        },
        {
          title: 'Mult.<br>pago',
          field: 'multiplicador_pago',
          sortable: true,
          colStyle: {
            width: '80px'
          }
        },
        {
          title: 'Serie',
          field: 'serie',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          colStyle: {
            width: '90px'
          }
        },
        {
          title: 'Error',
          field: 'error',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          colStyle: {
            width: '300px'
          },
          tdStyle: {
            'white-space': 'nowrap',
            'overflow': 'hidden',
            'text-overflow': 'ellipsis',
          }
        },
        {
          title: 'Actions',
          field: 'actions',
          fixed: 'right',
          thComp: 'EmptyTh',
          colStyle: {
            width: '65px'
          },
          tdStyle: {
            'height': '61px'
          }
        }
      ],
    }
  },
  methods: {
    getUbicacionesArbol(ubicacion_raiz_id) {
      const ubi_raiz = ubicacion_raiz_id ? ubicacion_raiz_id : this.ubicacionRaiz.value
      const list = this.ubicacionesArbol.filter(f=>f.id===ubi_raiz)
      return list
    },
    getTitle(arr,index,field){
      return arr[index][field]
    },
    getLabel(listName,id){
      const list = this[listName];
      return list.find(f=>f.id===Number(id))?.label
    },
    onTreeSelect() {
      // console.log(this.xdata)
      setTimeout(() => {
        this.updateHeightRows()
      }, 500);
    },
    onSelectActivity(registro) {
      let actividad = this.actividadC[registro.rowData.actividad_id];
      if (actividad == undefined || actividad.tipo_pago == 'variable') {
        registro.rowData.cantidad_costo = 0;
        registro.rowData.tiempo_extra = false;
      }
      registro.rowData.tipo = actividad.tipo
      registro.rowData.tipo_pago = actividad.tipo_pago
      registro.rowData.multiplicador_pago = actividad.multiplicador_pago
    },
    mapChunkData(item){
      let actividad = this.actividadC?.[item.payload.encabezado.actividad_id]||{};
      if (actividad.tipo_pago == 'variable') {
        item.payload.encabezado.cantidad_costo = 0;
        item.payload.encabezado.tiempo_extra = false;
      }
      return {
        dirty: false,
        errors: this.parseErrors(item.payload.encabezado),
        nanoid: item.payload.encabezado.nanoid,
        fechahora: item.payload.encabezado.fechahora,
        fechahora_amigable: this.dateFormat(item.payload.encabezado.fechahora),
        trabajador_id: item.payload.encabezado.trabajador_id,
        operador: item.payload.encabezado.operador,
        actividad_id: item.payload.encabezado.actividad_id,
        tipo: actividad.tipo,
        tipo_pago: actividad.tipo_pago,
        multiplicador_pago: actividad.multiplicador_pago,
        cantidad: item.payload.encabezado.cantidad,
        cantidad_costo: item.payload.encabezado.cantidad_costo ?? 0,
        tiempo_extra: item.payload.encabezado.tiempo_extra ?? false,
        ubicaciones: item.payload.encabezado.ubicaciones,
        serie: item.payload.encabezado.serie || '',
        package: item.payload.encabezado.package || null,
        version: item.payload.encabezado.version || null,
        firma: item.payload.encabezado.firma || null,
        ubicacion_raiz_id: item.payload.encabezado.ubicacion_raiz_id,
        error: item.error,
        file: item.file
      }

    },
    consultarDocumentos(from) {
      return this.syncConsultar_(`${from}::consultarDocumentos`).catch( error  => {
        console.log(error)
      })
    },
    parseErrors(item) {
      let errors = []

      let ubicacionesIds = this.ubicaciones.map(u => u.id)
      let ubicaciones = item.ubicaciones.filter(ubicacion => !ubicacionesIds.includes(ubicacion))
      let trabajador_activo = this.trabajadoresActivos.find(trabajador => trabajador.id === item.trabajador_id)
      let trabajador = this.trabajadores.find(trabajador => trabajador.id === item.trabajador_id)
      let actividad = this.actividades.find(actividad => actividad.id == item.actividad_id)

      // Si trabajador no esta activo pero existe, remplaza id por nombre, para facil identificación
      if (!trabajador_activo) {
        if (trabajador) {
          item.trabajador_id = trabajador.label
        }
        errors.push('trabajador_id')
      }
      if (!actividad) {
        errors.push('actividad_id')
      }
      if (ubicaciones.length || !item.ubicaciones.length) {
        errors.push('ubicaciones')
      }
      if (!item.cantidad) {
        errors.push('cantidad')
      }
      if (!item.cantidad_costo) {
        errors.push('cantidad_costo')
      }
      return errors
    }
  },
  computed: {
    _xdata(){
      return this.xdata.map(m=>({
        trabajador_id: this.getLabel('trabajadoresActivos',m.trabajador_id),
        actividad_id: this.getLabel('actividades',m.actividad_id),
      }))
    },
    dirtyDocuments() {
      return [...this.data]
        .filter(item => item.dirty == true)
        .map(item => {
          return {
            schema: "labores",
            payload: {
              encabezado: {
                nanoid: item.nanoid,
                package: item.package,
                version: item.version,
                firma: item.firma,
                serie: item.serie,
                fechahora: item.fechahora,
                trabajador_id: item.trabajador_id,
                operador: item.operador,
                actividad_id: item.actividad_id ?? null,
                cantidad: Number(item.cantidad || 0),
                cantidad_costo:
                  Number(item.cantidad_costo || 0) == 0
                    ? Number(item.cantidad || 0)
                    : Number(item.cantidad_costo || 0),
                tiempo_extra: item.tiempo_extra,
                ubicaciones: item.ubicaciones ?? [],
                ubicacion_raiz_id: item.ubicacion_raiz_id
              }
            },
            file: item.file
          };
        });
    },
    unDirtyDocuments() {
      return this.selection.map((item) => {
          return {
            schema: "labores",
            payload: {
              encabezado: {
                nanoid: item.nanoid,
                serie: item.serie,
                package: item.package,
                version: item.version,
                firma: item.firma,
                fechahora: item.fechahora,
                trabajador_id: item.trabajador_id,
                actividad_id: item.actividad_id ?? null,
                cantidad: Number(item.cantidad || 0),
                cantidad_costo:
                  Number(item.cantidad_costo || 0) == 0
                    ? Number(item.cantidad || 0)
                    : Number(item.cantidad_costo || 0),
                tiempo_extra: item.tiempo_extra,
                ubicaciones: item.ubicaciones ?? [],
                ubicacion_raiz_id: item.ubicacion_raiz_id
              }
            },
            file: item.file
          };
        });
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>
<style scoped>
>>> .td-overflow {
  overflow: hidden;
}
>>> .ceil-error {
  box-shadow: 0px 0px 0px 1000px #f5b4b5
}
>>> .ubi-error {
  background: #ffe2e2;
  border: 1px solid #ff8181;
  color: #ff8181;
}
>>> .error-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
>>> [name="RightFixedTableHeader"] .table thead th {
    vertical-align: bottom;
    border-bottom: none;
}
>>> [name="TableBodyWrapper"] {
  margin-top: 0 !important;
}
</style>
